import script from "./ESportsLiveOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportsLiveOverview.vue?vue&type=script&setup=true&lang=js"

import "./ESportsLiveOverview.vue?vue&type=style&index=0&id=854c70e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-854c70e4"]])

export default __exports__